import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/react';
import { Clock } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useIdleLogout } from '@/hooks';
import { useUserState } from '@/state';

const formatCountdown = (totalSeconds: number): string => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

// Pilnuje bezczynności i ostrzega przed auto-wylogowaniem. Montowany raz, w Layout.
export const SessionIdleGuard: FC = () => {
  const { t } = useTranslation();
  const { logout } = useUserState();
  const { isWarning, secondsLeft, stayLoggedIn } = useIdleLogout();

  return (
    <Modal
      isOpen={isWarning}
      isDismissable={false}
      isKeyboardDismissDisabled
      hideCloseButton
      backdrop="opaque"
      size="md"
      radius="sm"
    >
      <ModalContent>
        <ModalHeader className="flex items-center gap-2 text-lg leading-relaxed pb-2">
          <Clock size={18} />
          {t('auth.idle.title')}
        </ModalHeader>
        <ModalBody>
          <p className="text-sm leading-relaxed text-gray-600">
            {t('auth.idle.description', { countdown: formatCountdown(secondsLeft) })}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button variant="light" radius="full" onPress={() => logout()}>
            {t('auth.idle.logoutNow')}
          </Button>
          <Button
            radius="full"
            className="bg-black text-white px-6"
            onPress={stayLoggedIn}
          >
            {t('auth.idle.stayLoggedIn')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
